import React, { useRef, useEffect, useContext, useState } from "react";
import ChatModeratorKit from "../../data/ChatModeratorKit";
import { ChatMessageEnums } from "../../data/ChatMessageKit";
import { useRouter } from "next/router";
import VirtualRoomInvite from "./VirtualRoomInvite";

export default function ChatMessage({
  messageData,
  mutedList,
  me,
  isCorporateAgent = false,
  hostRoomUrl,
}) {
  const {
    author,
    message,
    timeStamp,
    type,
    videoRoomSlug,
    isHidden,
    isHighlighted,
    kind,
  } = messageData;
  const messageRef = useRef(null);
  const router = useRouter();

  function getFormattedTime() {
    const date = new Date(timeStamp);
    const hours = date.getHours();
    const minutes =
      date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;
    return `${hours}:${minutes}`;
  }

  function messageByCurrentUser() {
    return me.id === author.eventUserId;
  }

  function isMuted() {
    const list = mutedList || {};
    const isMuted = Object.entries(list).some((event_user) => {
      const [eventUserId, muted] = event_user;

      return muted && author.eventUserId == eventUserId;
    });

    return isMuted;
  }

  function toggleIsHidden() {
    if (type === "public" && me.isModerator) {
      ChatModeratorKit.setMessageHidden(messageData, !isHidden);
    }
  }

  function toggleIsHighlighted() {
    if (type === "public" && me.isModerator) {
      ChatModeratorKit.setMessageHighlight(messageData, !isHighlighted);
    }
  }

  function toggleIsMuted() {
    if (type === "public" && me.isModerator /*&& checkHasRan("isMuted")) */) {
      ChatModeratorKit.setMuteMessageAuthor(messageData, !isMuted());
    }
  }

  // function handleRedirectToVideoroom() {
  //     const { eventSlug } = messageData.getUrlParams()
  //     router.push(`/${eventSlug}/${videoRoomSlug}`)
  // }

  function getFormattedMessage(message) {
    return (
      <>
        {message.split("").map((char, i) => {
          return <>{/\n/g.test(char) ? <br /> : char}</>;
        })}
      </>
    );
  }

  return (
    <>
      {messageByCurrentUser() && type !== "public" && (
        <span
          className={`
        timestamp mt-2 d-flex justify-content-end me-3 
        ${isCorporateAgent && "corporate-author"} 
        ${
          !messageByCurrentUser() && kind === ChatMessageEnums.ANNONCEMENT
            ? "d-none"
            : ""
        }`}
        >
          <span className="me-2">
            {type === "corporate" &&
              isCorporateAgent &&
              author.displayName &&
              `${author.displayName}`}
          </span>
          {getFormattedTime()}
        </span>
      )}
      <div
        className={` 
        chat-message ps-3 pe-3 pb-2 pt-0 w-100  text-break 
        ${isHidden ? "hidden-chat" : ""} 
        ${!me.isModerator && isHidden ? "d-none" : ""} 
        ${type === "public" && me.isModerator && "chat-message-hover"} 
        ${
          messageByCurrentUser() &&
          !videoRoomSlug &&
          type !== "public" &&
          "d-flex justify-content-end"
        }
        ${
          !messageByCurrentUser() && kind === ChatMessageEnums.ANNONCEMENT
            ? "d-none"
            : ""
        }
      `}
        ref={messageRef}
      >
        {type === "public" && me.isModerator && (
          <div className={`button-svg-group d-inline float-end`}>
            <button
              className={`admin-icon ${
                isHighlighted ? "highlighted-message" : ""
              }`}
              onClick={() => toggleIsHighlighted()}
            >
              <span className={`${isHighlighted ? "d-block" : "d-none"} me-2`}>
                <img src="/assets/starhighlighted.svg" width="15" height="15" />
              </span>
              <span className={`${isHighlighted ? "d-none" : "d-inline"} me-2`}>
                <img src="/assets/star.svg" width="15" height="15" />
              </span>
            </button>
            <button
              className={`admin-icon ${isMuted() ? "highlighted-message" : ""}`}
              onClick={() => toggleIsMuted()}
            >
              <span className={`${isMuted() ? "d-block" : "d-none"} me-2`}>
                <img src="/assets/mutedcolored.svg" width="14" height="14" />
              </span>
              <span className={`${isMuted() ? "d-none" : "d-inline"} me-2`}>
                <img src="/assets/mutednotcolored.svg" width="14" height="14" />
              </span>
            </button>
            <button
              className={`admin-icon ${isHidden ? "highlighted-message" : ""}`}
              onClick={() => toggleIsHidden()}
            >
              <span className={`${isHidden ? "d-block" : "d-none"} me-2`}>
                <img
                  src="/assets/hiddenclicked.svg"
                  width="11.9"
                  height="11.9"
                />
              </span>
              <span className={`${isHidden ? "d-none" : "d-inline"} me-2`}>
                <img
                  src="/assets/hiddennotcoloured.svg"
                  width="11.9"
                  height="11.9"
                />
              </span>
            </button>
          </div>
        )}

        <p
          className={`m-0 ${
            messageByCurrentUser() && type !== "public" ? "d-none" : "d-inline"
          } me-4`}
        >
          <span
            className={`${
              author.isModerator ? "moderator-title" : "user-title"
            } ${isCorporateAgent && "corporate-author"}`}
          >
            {author.isModerator && (
              <span className={`me-2`}>
                <img
                  src="/assets/moderatorstargreen.svg"
                  width="10"
                  height="10"
                />
              </span>
            )}
            {author.displayName}
            {author.title ? ` - ${author.title}` : ""}
          </span>

          <span
            className={`ms-2 timestamp ${
              isCorporateAgent && "corporate-author"
            }`}
          >
            {getFormattedTime()}
          </span>
        </p>

        {type === "public" && (
          <p className={`chat-message__message mt-1 m-0 `}>
            {getFormattedMessage(message)}
          </p>
        )}

        {type === "private" && kind === ChatMessageEnums.TEXT && (
          <p
            className={`chat-message__message private-chat-message ${
              messageByCurrentUser() && "message-current-user"
            }  mt-2 m-0 `}
          >
            {getFormattedMessage(message)}
          </p>
        )}

        {type === "corporate" &&
          !isCorporateAgent &&
          kind === ChatMessageEnums.TEXT && (
            <p
              className={`chat-message__message private-chat-message ${
                messageByCurrentUser() && "message-current-user"
              } mt-2 m-0 `}
            >
              {getFormattedMessage(message)}
            </p>
          )}

        {type === "corporate" &&
          isCorporateAgent &&
          kind === ChatMessageEnums.TEXT && (
            <p
              className={`chat-message__message corporate-chat-message ${
                messageByCurrentUser() && "message-current-user"
              } p-3 mt-2 m-0 `}
            >
              {getFormattedMessage(message)}
            </p>
          )}
        {type === "corporate" &&
          isCorporateAgent &&
          kind === ChatMessageEnums.ANNONCEMENT && (
            <p
              className={`chat-message__message corporate-chat-message ${
                messageByCurrentUser() && "message-current-user"
              } p-3 mt-2 m-0 `}
            >
              {getFormattedMessage(message)}
            </p>
          )}

        {videoRoomSlug && (
          // <VirtualRoomInvite onClick={handleRedirectToVideoroom} />
          <VirtualRoomInvite
            urlParams={messageData.getUrlParams()}
            videoRoomSlug={videoRoomSlug}
            isCorporateAgent={isCorporateAgent}
            hostRoomUrl={hostRoomUrl}
          />
        )}
      </div>
    </>
  );
}
